import { render } from "./DownloadManager.vue?vue&type=template&id=c7fca34e&scoped=true"
import script from "./DownloadManager.vue?vue&type=script&lang=js"
export * from "./DownloadManager.vue?vue&type=script&lang=js"

import "./DownloadManager.vue?vue&type=style&index=0&id=c7fca34e&lang=scss&scoped=true"

import exportComponent from "/home/app/rails/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7fca34e"]])

export default __exports__